import React, { useState, useEffect, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import NewPatientPhoto from './NewPatientPhoto';
import style from './NewPatientPhotos.module.css';
import style2 from './NewPatientPhoto.module.css';
import * as actionTypes from '../../../store/NewPatient/actionType';
import { connect } from 'react-redux';
import { useLang } from '../../../util/lang';
import axios from '../../../axios-default';
import AlertDialog from '../../Dialog/Dialog';
import { getWebAbsPath } from '../../../util/path';
import join from 'url-join';
import { ApiServerUrl } from '../../../config.json';
import { getCBCT } from '../../../util/file';
import LoadingSpinner from '../../Loader/LoadingSpinner';

const Radiograph = (props) => {
    const [dbxPopup, setDbxPopup] = useState(false);
    const [cbctLoading, setCbctLoading] = useState(true);
    const get = useLang('NewPatient');

    const timerRef = useRef(null);
    const dbxRef = useRef({
        folder_name: '',
        url: '',
    });
    const isCbctUploadedInDbx = /^dbx::/.test(props.imageData('cbct').data) && !!props.dbxFileCount;

    const fetchCbctFileCount = async (folderName) => {
        try {
            const file_list = await axios.get(`dropbox/getFileCount/${folderName}/0`);
            if (file_list.data.file_count > 0) {
                props.setDbxFileCount(file_list.data.file_count);
            }
        } catch (e) {
            console.error('Error fetching file count', e);
        }
    };

    const createDropboxLink = async () => {
        if (!dbxRef.current.url.length || !dbxRef.current.folder_name.length) {
            const result = await axios.get('dropbox/getLink');
            dbxRef.current.folder_name = result.data.folder_name;
            dbxRef.current.url = result.data.request_url;
            props.handleChange('cbct', `dbx::${dbxRef.current.folder_name}`);
            if (timerRef.current) clearInterval(timerRef.current);
            props.setDbxFileCount(0);
        }
        window.open(dbxRef.current.url, '_blank');
        timerRef.current = setInterval(async () => {
            await fetchCbctFileCount(dbxRef.current.folder_name);
        }, 5000);
    };

    useEffect(() => {
        let cancelled = false;
        setCbctLoading(true);
        const load = async () => {
            setCbctLoading(true);

            const cbctData = props.imageData('cbct').data;
            if (typeof cbctData === 'string' && /^dbx::/.test(cbctData)) {
                const folderName = cbctData.replace('dbx::', '');
                dbxRef.current.folder_name = folderName;
                await fetchCbctFileCount(folderName);
            }

            if (!cancelled) {
                setCbctLoading(false);
            }
        };

        load();
        return () => {
            cancelled = true;
            clearInterval(timerRef.current);
        }
    }, []);

    const handleDbxPopup = async (open) => {
        if (open) {
            setDbxPopup(true);
        } else {
            setDbxPopup(false);
            await createDropboxLink();
        }
    };

    return (
        <Grid container spacing={1} className={style.twoColumnImage}>
            <Grid item xs={12} sm={4}>
                <li>
                    <NewPatientPhoto
                        mode={props.mode}
                        type="radio"
                        imageId="front_with_smile"
                        imageUploaded={props.imageUploaded('front_with_smile')}
                        imageData={props.imageData('front_with_smile')}
                        label={get(':uploadType.uploadPhotoLater')}
                        labelSecondary="Will not submit"
                        imageName="bg_xray1.png"
                        uploadLater={props.uploadLater}
                        // mandatoryImage={true}
                        will_not_upload={true}
                        // will_not_upload={props.parent === 'refinement' ? true : false}
                        will_not_upload_label={get(':uploadType.willNotUploadXray')}
                        imageLabel={`${get('radiographs.orthopantomogram')} - ${get(':uploadType.stronglyRecommended')}`}
                        labelUnderImage=" "
                        handleRoatate={(degree) => {
                            props.handleRoatate('front_with_smile', degree);
                        }}
                        handleChange={(file) => {
                            props.handleChange('front_with_smile', file);
                        }}
                    />
                </li>
            </Grid>
            <Grid item xs={12} sm={4}>
                <li>
                    <NewPatientPhoto
                        mode={props.mode}
                        type="radio"
                        imageId="side_with_smile"
                        imageUploaded={props.imageUploaded('side_with_smile')}
                        imageData={props.imageData('side_with_smile')}
                        label={get(':uploadType.uploadXrayLater')}
                        imageName="bg_xray2.png"
                        uploadLater={props.uploadLater}
                        will_not_upload={true}
                        will_not_upload_label={get(':uploadType.willNotUploadXray')}
                        imageLabel={`${get('radiographs.lateralCephalogram')} - ${get(':uploadType.stronglyRecommended')}`}
                        labelUnderImage=" "
                        handleRoatate={(degree) => {
                            props.handleRoatate('side_with_smile', degree);
                        }}
                        handleChange={(file) => {
                            props.handleChange('side_with_smile', file);
                        }}
                    />
                </li>
            </Grid>

            {props.imageData('cbct').uploaded &&
            typeof props.imageData('cbct').data === 'string' &&
            props.imageData('cbct').data.includes('s3:') ? (
                <Grid item xs={12} sm={4}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                        }}
                    >
                        CBCT files are inside the RFS file
                    </div>
                </Grid>
            ) : (
                <Grid item xs={12} sm={4}>
                    {props.mode == 'view' ? (
                        isCbctUploadedInDbx ? (
                            <div style={{ marginTop: '10%', marginLeft: '35%' }}>
                                <span
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        getCBCT(
                                            `CBCT_${props.case_id}.zip`,
                                            join(
                                                ApiServerUrl,
                                                '/api/dropbox/downloadFile',
                                                props.imageData('cbct').data.replace('dbx::', ''),
                                                props.case_id
                                            )
                                        )
                                    }
                                >
                                    Download Zip
                                </span>
                            </div>
                        ) : (
                            <li>
                                <NewPatientPhoto
                                    mode={props.mode}
                                    type="radio"
                                    imageId="cbct"
                                    imageUploaded={props.imageUploaded('cbct')}
                                    imageData={props.imageData('cbct')}
                                    label={get(':uploadType.uploadXrayLater')}
                                    imageName="cbct.png"
                                    imageLabel={`${get('radiographs.cbct_dicom')} - ${get(':uploadType.optional')}`}
                                    labelUnderImage="FOV 16(W)X10(H)"
                                    handleRoatate={(degree) => {
                                        props.handleRoatate('cbct', degree);
                                    }}
                                    handleChange={(file) => {
                                        props.handleChange('cbct', file);
                                    }}
                                />
                            </li>
                        )
                    ) : ['CN'].includes(process.env.REACT_APP_ENV) ? (
                        <li>
                            <NewPatientPhoto
                                mode={props.mode}
                                type="radio"
                                imageId="cbct"
                                imageUploaded={props.imageUploaded('cbct')}
                                imageData={props.imageData('cbct')}
                                label={get(':uploadType.uploadXrayLater')}
                                imageName="cbct.png"
                                imageLabel={`${get('radiographs.cbct_dicom')} - ${get(':uploadType.optional')}`}
                                labelUnderImage="FOV 16(W)X10(H)"
                                handleRoatate={(degree) => {
                                    props.handleRoatate('cbct', degree);
                                }}
                                handleChange={(file) => {
                                    props.handleChange('cbct', file);
                                }}
                            />
                        </li>
                    ) : (
                        <>
                            <div style={{ width: '100%' }}>
                                <div className={style2.card}>
                                    <div
                                        className={style2.uploadBtnWrapper}
                                        onClick={async () => await handleDbxPopup(true)}
                                    >
                                        <button className={style2.btn}>+</button>
                                        <span className={style2.ImageLabelText}>
                                            {get('radiographs.cbct_dicom')} - {get(':uploadType.optional')}
                                        </span>
                                    </div>
                                    <div className={style2.cardImage}>
                                        <img src={getWebAbsPath('/img/cbct.png')} />
                                    </div>
                                    <div className={style2.uploadBtnWrapper}>
                                        <span className={style2.ImageLabelText}></span>
                                    </div>
                                </div>
                                <div className={style2.uploadFooter}>
                                    {cbctLoading ? (<LoadingSpinner />) : (
                                    <p
                                        style={{
                                            fontSize: isCbctUploadedInDbx ? 24 : 18,
                                            fontWeight: isCbctUploadedInDbx ? 'bold' : 'normal',
                                            color: isCbctUploadedInDbx ? 'red' : 'inherit',
                                            marginBlockEnd: 0,
                                            marginLeft: 15,
                                            textAlign: 'center',
                                            transition: 'all 0.3s ease',
                                        }}
                                    >
                                        {props.dbxFileCount > 0
                                            ? `${props.dbxFileCount} file(s) uploaded`
                                            : 'No files uploaded'}
                                    </p>)}
                                </div>
                            </div>
                            <AlertDialog
                                title="Upload Instruction"
                                dialogOpen={dbxPopup}
                                handleDialogClose={async () => await handleDbxPopup(false)}
                                styleDialog={{ width: '630px', maxWidth: '630px' }}
                                content={'1. Select and upload the CBCT files and any other required documents.\n2. Enter the full name and email address of the treating doctor in the designated fields. This information is essential for us to match your case efficiently in our system.\n​3. Please do not close or refresh the page until the upload finishes.\n​4. Return to the TrioClear Submission Portal and continue with the case submission.​​'}
                            />
                        </>
                    )}
                </Grid>
            )}
        </Grid>
    );
};

const mapStateToProps = (store) => {
    return {
        cbctFiles: store.newPatientReducer.cbctFiles,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleCbctFile: (value, fileName) =>
            dispatch({ type: actionTypes.NEW_PATIENT_CBCT, value: value, name: fileName }),
        handleRemoveCbctFile: (value) => dispatch({ type: actionTypes.NEW_PATIENT_REMOVE_CBCT, value: value }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radiograph);
